import { api } from "../api";
import { EventResponse } from "../../../types/types";

type RecentEventsResponse = {
    events: EventResponse[];
    cursor: number;
    hasMore: boolean;
};

const findRecentEventsByCustomer = async (token: string, customerId: number, afterId: number) => {
    const response = await api.get<RecentEventsResponse>(`/events/${customerId}/recent`, {
        params: { afterId },
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

export default findRecentEventsByCustomer;
